import { useState } from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    num: '01',
    icon: 'ri-home-4-line',
    title: 'Residential Settlements',
    path: '/services/residential-settlements',
    desc: 'Smooth, on-time closings for home buyers and sellers throughout southeastern Pennsylvania. We coordinate every detail so your closing day is stress-free.',
  },
  {
    num: '02',
    icon: 'ri-building-2-line',
    title: 'Commercial Closings',
    path: '/services/commercial-closings',
    desc: 'Expert handling of complex commercial real estate transactions — offices, retail, multi-unit, and land — with precision and efficiency.',
  },
  {
    num: '03',
    icon: 'ri-shield-check-line',
    title: 'Title Insurance',
    path: '/services/title-insurance',
    desc: 'Comprehensive owner and lender title insurance protecting your investment from hidden defects, liens, and ownership disputes.',
  },
  {
    num: '04',
    icon: 'ri-search-eye-line',
    title: 'Title Searches',
    path: '/services/title-searches',
    desc: 'Thorough examination of public records going back decades to verify clear ownership and uncover any issues before closing.',
  },
  {
    num: '05',
    icon: 'ri-exchange-line',
    title: '1031 Exchanges',
    path: '/services/1031-exchanges',
    desc: 'Defer capital gains taxes by exchanging investment properties under IRS Section 1031 with experienced coordination and compliance.',
  },
  {
    num: '06',
    icon: 'ri-bank-line',
    title: 'Refinancing Services',
    path: '/services/refinancing',
    desc: 'Streamlined refinance closings for homeowners looking to lower rates or access equity in their Pennsylvania property.',
  },
  {
    num: '07',
    icon: 'ri-file-text-line',
    title: 'Deed Preparation',
    path: '/services/deed-preparation',
    desc: 'Accurate preparation and recording of all deed types in compliance with Pennsylvania law and county recording requirements.',
  },
  {
    num: '08',
    icon: 'ri-file-search-line',
    title: 'Lien Searches',
    path: '/services/lien-searches',
    desc: 'Comprehensive searches covering federal and state tax liens, judgment liens, mechanic\'s liens, and municipal utility claims.',
  },
];

const ServicesOverview = () => {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <section className="bg-white" id="services">
      {/* Section header */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-px bg-[#c9a84c]"></div>
              <span className="text-[#c9a84c] text-xs font-bold tracking-[0.3em] uppercase">What We Do</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-[#0f0f0f] leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Settlement Solutions<br />for Every Transaction
            </h2>
          </div>
          <Link
            to="/services"
            className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.15em] uppercase text-[#0f0f0f] hover:text-[#c9a84c] transition-colors whitespace-nowrap cursor-pointer group"
          >
            View All Services
            <div className="w-5 h-5 flex items-center justify-center border border-current rounded-full group-hover:bg-[#c9a84c] group-hover:border-[#c9a84c] group-hover:text-white transition-all">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
        </div>
      </div>

      {/* Service rows */}
      <div className="border-t border-stone-100">
        {services.map((svc, i) => (
          <Link
            key={svc.num}
            to={svc.path}
            className={`block border-b border-stone-100 cursor-pointer transition-all duration-300 ${
              hovered === i ? 'bg-[#0f0f0f]' : 'bg-white'
            }`}
            onMouseEnter={() => setHovered(i)}
            onMouseLeave={() => setHovered(null)}
          >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-7 flex items-center gap-8">
              <span className={`text-xs font-bold tracking-widest w-8 shrink-0 transition-colors duration-300 ${hovered === i ? 'text-[#c9a84c]/50' : 'text-stone-300'}`}>
                {svc.num}
              </span>
              <div className={`w-10 h-10 flex items-center justify-center shrink-0 transition-colors duration-300 ${hovered === i ? 'text-[#c9a84c]' : 'text-stone-400'}`}>
                <i className={`${svc.icon} text-xl`}></i>
              </div>
              <h3 className={`text-base font-bold w-56 shrink-0 transition-colors duration-300 ${hovered === i ? 'text-white' : 'text-[#0f0f0f]'}`}>
                {svc.title}
              </h3>
              <p className={`text-sm leading-relaxed flex-1 hidden md:block transition-colors duration-300 ${hovered === i ? 'text-white/50' : 'text-stone-400'}`}>
                {svc.desc}
              </p>
              <div className={`w-8 h-8 flex items-center justify-center shrink-0 rounded-full border transition-all duration-300 ${hovered === i ? 'border-[#c9a84c] text-[#c9a84c]' : 'border-stone-200 text-stone-300'}`}>
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default ServicesOverview;
